import React from "react";
import { formatNumber, formatCurrency, safeNum } from "./passiveLoadHelpers";

const savingsScenarios = [
  { name: "Conservador", reduction: 0.1 },
  { name: "Medio", reduction: 0.25 },
  { name: "Óptimo", reduction: 0.4 },
];

const InfoIcon = ({ text }) => (
  <span className="metric-info-icon" title={text} aria-label={text}>
    <i className="bi bi-info-circle" />
  </span>
);

const HeaderWithInfo = ({ children, info, className = "" }) => (
  <th className={className}>
    <span className="header-with-info">
      <span>{children}</span>
      <InfoIcon text={info} />
    </span>
  </th>
);

const TitleWithInfo = ({ children, info }) => (
  <span className="title-with-info">
    <span>{children}</span>
    <InfoIcon text={info} />
  </span>
);

const LabelWithInfo = ({ children, info }) => (
  <span className="metric-label">
    <span>{children}</span>
    <InfoIcon text={info} />
  </span>
);

const PassiveSavingsTable = ({ data }) => {
  if (!data || !data.totals) return null;

  const totals = data.totals;

  const nonProductiveEnergy =
    safeNum(totals.nonProductiveEnergy, 0) ||
    safeNum(totals.passiveNightEnergy, 0);

  const costPassive = totals.cost ?? totals.costPassive ?? 0;

  if (nonProductiveEnergy === 0 && costPassive === 0) return null;

  return (
    <div className="passive-load-summary passive-savings">
      <h3>
        <TitleWithInfo info="Estimación del ahorro posible si se reduce una parte del consumo fuera de horario.">
          Ahorro potencial
        </TitleWithInfo>
      </h3>

      <div className="passive-summary-table">
        <table>
          <thead>
            <tr>
              <HeaderWithInfo info="Nivel de reducción estimado sobre el consumo fuera de horario.">
                Escenario
              </HeaderWithInfo>

              <HeaderWithInfo
                className="text-right"
                info="Porcentaje de reducción aplicado al consumo fuera de horario."
              >
                Reducción
              </HeaderWithInfo>

              <HeaderWithInfo
                className="text-right"
                info="Energía que se podría ahorrar según el escenario seleccionado."
              >
                Ahorro (kWh)
              </HeaderWithInfo>

              <HeaderWithInfo
                className="text-right"
                info="Ahorro económico estimado según el costo asociado al consumo fuera de horario."
              >
                Ahorro estimado [$]
              </HeaderWithInfo>
            </tr>
          </thead>

          <tbody>
            {savingsScenarios.map((scenario) => {
              const energySave = nonProductiveEnergy * scenario.reduction;
              const costSave =
                costPassive != null && costPassive !== ""
                  ? costPassive * scenario.reduction
                  : null;

              const info =
                scenario.name === "Conservador"
                  ? "Escenario prudente: supone una reducción baja y alcanzable."
                  : scenario.name === "Medio"
                  ? "Escenario intermedio: supone una mejora moderada."
                  : "Escenario óptimo: supone una reducción alta mediante acciones de optimización.";

              return (
                <tr key={scenario.name}>
                  <td>
                    <LabelWithInfo info={info}>{scenario.name}</LabelWithInfo>
                  </td>

                  <td className="value-number">
                    {Math.round(scenario.reduction * 100)}%
                  </td>

                  <td className="value-number">
                    {formatNumber(energySave)}
                  </td>

                  <td className="value-number">
                    {costSave != null ? formatCurrency(costSave) : "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PassiveSavingsTable;